import React from "react";

export default function About() {
  return (
        <section className='section'>
          <h3 className='section-title'>About</h3>
          <p className='section-body'>Self-starting Front End Developer, currently studying with Code institute for a Diploma.  Presents ability to produce clean, maintainable, and re-usable code.  Experience building creative responsive websites using HTML, CSS, and JavaScript.  Through my course I have discovered a determination to solve issues and problems creating a streamline user experience, with completing required and personal projects in my spare time.</p>
        </section>
  );
}